module.exports = __webpack_public_path__ + "static/media/homerightimg1.200e48af.jpg";